import useCashierLink from '~/client/hooks/feature/useCashierLink';
import useRouter from '~/client/hooks/router/useRouter';
import useAbTest from '~/client/hooks/useAbTest';
import useAgentData from '~/client/hooks/useAgentData';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useUserBalance from '~/client/hooks/user/useUserBalance';
import useSite from '~/client/hooks/useSite';

const useDepositToPlay = () => {
  const { realBalance } = useUserBalance();
  const { asPath, push } = useRouter();
  const isLoggedIn = useIsLoggedIn();
  const { isMobile } = useAgentData();
  const { isBitcasino } = useSite();
  const { link: cashierDeposit } = useCashierLink({ cashierPath: 'deposit' });
  const { link: cashierHome } = useCashierLink({ cashierPath: 'home' });

  const { showVariant1, showVariant2 } = useAbTest({
    name: 'depositToPlay',
    device: 'mobile',
  });

  const getURLPath = () => {
    if (showVariant1) {
      return `${cashierHome}&redirect=${asPath}`;
    }
    return `${cashierDeposit}&redirect=${asPath}`;
  };

  const isUserFundsEnough = realBalance ?? 0 > 0;
  const isDepositToPlayBtnVisible =
    (showVariant1 || showVariant2) &&
    !isUserFundsEnough &&
    isLoggedIn &&
    isMobile &&
    isBitcasino;

  const urlPath = isDepositToPlayBtnVisible && getURLPath();

  const handleDepositToPlay = () => {
    push(`${urlPath}`);
  };

  return { isDepositToPlayBtnVisible, handleDepositToPlay };
};

export default useDepositToPlay;
